/* eslint-disable @typescript-eslint/no-unnecessary-condition */
import { NumericDiff } from "components/search/input/DifferencePanel/common";
import { NameBasedTargetBasketItem } from "store/api/generatedApi";

import { CategoryConfigFactory } from "components/search/input/DifferencePanel/common";

export const TargetBasketItemConfigFactory: CategoryConfigFactory<
  NameBasedTargetBasketItem
> = ({ t, formatNumber2DP }) => ({
  target_num_baskets: {
    title: t("targetBaskets"),
    format: (val) => val,
    renderDiff: ({ updatedVal, previousVal }) => (
      <NumericDiff
        previous={previousVal ?? 0}
        updated={updatedVal ?? 0}
        format={formatNumber2DP}
      />
    ),
  },
});
